module.exports = __webpack_public_path__ + "img/icon_dtjq_01.fe9d3267.png";